import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { loadReviewProducts, loadSpecialProducts } from '@app/actions/shoppingmall/product.action';
import { setWAlert } from '@app/actions/w-alert.action';
import { ActionConstant } from '@app/common/constant/action-constant';
import { MessageConstant } from '@app/common/constant/message.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { ProductState } from '@app/selectors/shoppingmall/product.selector';
import { getSmWownet, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { environment } from '@enviroments/environment';
import { Store } from '@ngrx/store';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';

declare const handleDecorElements: any;

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.css']
})

export class HomePageComponent implements OnInit {
    smWownet$ = new Observable<SmWownetModel>;

    urlWownet: string = "";
    lMemRegYn: string = "";
    lshowPdtYn: string = "";
    isLogined: boolean = AuthUtil.isLogined();

    pathKind: string = "PC";
    
    constructor(
        private _smWownetStateStore: Store<SmWownetState>,
        private _router: Router,
        private _overlayLoadingStore: Store<OverlayLoadingState>,
        private _productStore: Store<ProductState>,
        private _deviceService: DeviceDetectorService,
        private _wAlertStore: Store<WAlertState>
    ) {
        this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
    }

    ngOnInit(): void {

      let flagPoint:any = localStorage.getItem("flagPoint");
      if (ValidationUtil.isNotNullAndNotEmpty(flagPoint)) {
        flagPoint = JSON.parse(flagPoint);
        if(flagPoint > 0){
          this._wAlertStore.dispatch(
            setWAlert({ 
              wAlert: { 
                icon: WAlertConstant.successful, 
                message: MessageConstant.msgPointLuckLogin,
              } 
            })
          );
          localStorage.removeItem("flagPoint");
        }
      }

      this.smWownet$.subscribe(res => {
          if (ValidationUtil.isNotNullAndNotEmpty(res)) {
              this.lMemRegYn = res.lMemRegYn;
              this.urlWownet = res.urlWownet;
              this.lshowPdtYn = res.lShowPdtYn;
          }
      });
      
      this.pathKind = this._deviceService.isDesktop()? 'PC' : 'PHONE'; 

      handleDecorElements();
      this.loadProducts();
      this.loadReviewProducts();
    }


    loadProducts(): void {
        const params = this.getParams();
        if (params.page < 0) return;
        // if (ValidationUtil.isNullOrEmpty(params.cateCd)) return;
    
        this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
        this._productStore.dispatch(loadSpecialProducts({ params: params }));
    }
    
    getParams(): any {        
        let member = AuthUtil.getLoginedInfo();
        let userid = '';
        let packageText = '';
        if (member) {
          userid = ConvertUtil.convertToString(member.userid);
          packageText = member.groupCode;
        }
    
        const params = {
          comId: environment.comId,
          cateCd: '',
          pathKind: this.pathKind,
          userid: userid,
          type: 0,
          packageText : packageText
        }
    
        return params;
    }

    loadReviewProducts(): void {
      const params = this.getReviewParams();
      if (params.page < 0) return;
      // if (ValidationUtil.isNullOrEmpty(params.cateCd)) return;
  
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
      this._productStore.dispatch(loadReviewProducts({ params: params }));
  }
  
  getReviewParams(): any {        
    let member = AuthUtil.getLoginedInfo();
    let userid = '';
    if (member) {
      userid = ConvertUtil.convertToSring(member.userid);
    }

    const params = {
      comId: environment.comId,
      cateCd: '',
      pathKind: this.pathKind,
      key: '',
      page: 0,   //sample
      len: 3,    //sample
      userid: userid
    }

    return params;
  }
    
  getItemOfProduct(item: any) {
    if (ValidationUtil.isNotNullAndNotEmpty(item.pdtCd)) {
      if (this.lshowPdtYn !== "Y" && !this.isLogined) {
        this._wAlertStore.dispatch(
          setWAlert({ 
            wAlert: { 
              icon: WAlertConstant.confirm, 
              message: MessageConstant.msgRequiredLogin, 
              action: ActionConstant.actionConfirmLogined 
            } 
          })
        );
      } else {
        let tmp: any = [];
        let pdtClickRecent: any = localStorage.getItem("pdtClickRecent");
        if(ValidationUtil.isNotNullAndNotEmpty(pdtClickRecent)){
          tmp = JSON.parse(pdtClickRecent);
          let count = 0;
          for(let i=0; i<tmp.length;i++){
            if(item.pdtCd == tmp[i].pdtCd){
              count++;
            }
          }

          if(count == 0){
            if(tmp.length == 8){
              tmp.splice(0,1);
              tmp.push(item);
            } else {
              tmp.push(item);
            }
          } 
        } else {
          tmp.push(item);
        }
        localStorage.setItem("pdtClickRecent", JSON.stringify(tmp));
        window.dispatchEvent(new Event('storage'));
        
        this._router.navigate([`/shopping-mall/product/${item.pdtCd}`]);
      }
    }
  }
}
